import { render, staticRenderFns } from "./Page-Members.vue?vue&type=template&id=42b2d474&"
import script from "./Page-Members.vue?vue&type=script&lang=js&"
export * from "./Page-Members.vue?vue&type=script&lang=js&"
import style0 from "./Page-Members.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports